import AdviceRegister from "../../features/adviceregister";
import { AdviceRegisterDefaultFilters, FilterProvider } from "../../hooks/FilterContext";
import withProviders from "../../hooks/withProviders";

const ManagementReportsAdviceRegisterPage = () => <AdviceRegister />

export default withProviders([FilterProvider, { defaultFilters: AdviceRegisterDefaultFilters, filterStore: 'management.reports.advice-register' }])(ManagementReportsAdviceRegisterPage);
